import { LayoutService } from './../../core/layout.service';
import { DisplayOptions, Footer } from './../../core/display-options';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DisplayOptionsService } from '../../core/display-options.service';

@Component({
  standalone: false,
  selector: 'car-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {

  public displayOptions: DisplayOptions;
  public showDefaultFooter: boolean;
  public showSorFooter: boolean;
  private footersItems: Footer[];
  private footersCopyrights: Footer[];

  constructor(
    private displayOptionsService: DisplayOptionsService,
    private layoutService: LayoutService
  ) {
    this.displayOptions = this.displayOptionsService.getOptions();
    this.showSorFooter = this.displayOptions && this.displayOptions.optionsId && (this.displayOptions.optionsId.startsWith("c1:e3"));

    if (!this.showSorFooter) {
      this.showDefaultFooter = true;
    }

    this.footersItems = [];
    this.footersCopyrights = [];

    if (this.displayOptions && this.displayOptions.footers) {
      this.displayOptions.footers.forEach((key, index, context) => {
        if (index < context.length - 1) {
          this.footersItems.push(key);
        } else {
          key.text_link = this.overrideFooterSORVariables(key.text_link);
          this.footersCopyrights.push(key);
        }
      });
    }
  }

  private overrideFooterSORVariables(text: string): string {
    let year = new Date().getFullYear().toString();
    text = text.replace(/\[Year\]/gi, year);
    text = text.replace(/\[SiteNameExtension\]/gi, this.displayOptions.program_long_name,);
    return text;
  }

  isExtendedPadding: boolean;
  private layoutStates$: Subscription;

  ngOnInit() {
    this.layoutStates$ = this.layoutService.layoutStates.subscribe(
      state => this.isExtendedPadding = state.isExtendedFooter
    );
  }

  ngOnDestroy() {
    this.layoutStates$?.unsubscribe();
  }
}
